<template>
  <div class="conversation">
    <h1>
      {{
        contact
          ? contact.nom.charAt(0).toUpperCase() + contact.nom.slice(1)
          : "Choisir un contact"
      }}
    </h1>
    <MessagesFeed :contact="contact" :messages="messages" />
    <MessageComposer v-if="messages.length > 0" @send="sendMessage" />

    <div v-if="messages.length > 0" class="col-md-4 styleSendImage">
      <div>
        <label class="custom-file-upload">
          <input
            ref="image"
            type="file"
            @change="previewImageRio"
            class="input-file image"
            accept="image/x-png, image/gif, image/jpeg"
          />
          <img
            class="hideWeb"
            src="https://img.icons8.com/color/48/000000/add-image.png"
          />
        </label>

        <div class="image-preview" v-if="imageDataRio.length > 0">
          <img width="25%" class="preview" :src="imageDataRio" />
          <br>
          <CButton
            @click.prevent="submitMsg"
            type="submit"
            size="sm"
            color="primary"
            ><CIcon name="cil-check-circle" /> Envoyer</CButton
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MessagesFeed from "./MessagesFeed";
import MessageComposer from "./MessageComposer";

import { apiDomain } from "../../config";
import axios from "axios";
export default {
  props: {
    contact: {
      type: Object,
      default: null,
    },
    messages: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      imageDataRio: "",
      mesg:{},
      nameContact: this.$store.state.user.nom,
    };
  },

   created() {
   
   // this.fetchListesMessage(this.contact.depanneur_id);

  },
  methods: {
/*  fetchListesMessage(id) {
      let vm = this;
      fetch(
        `${apiDomain}/api/conversation/${contact.depanneur_id} ` + "?token=" + this.$store.state.token
      )
        .then((res) => res.json())
        .then((res) => {
          this.messages = response.data;
          this.mesg = response.data;
         
        });
        
    }, */

    submitMsg(e) {
      this.isCreatingAnn = true;
      let formData = new FormData();

      formData.append("from", this.contact.client_id);
      formData.append("to", this.contact.depanneur_id);
      formData.append("image", this.$refs.image.files[0]);
      formData.append("nameContact", this.nameContact);

      axios
        .post(
          `${apiDomain}/api/sendPrivateMessage2`,

          formData,
          {
            body: JSON.stringify(this.annonce),
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        )

        .then((res) => {
           

          this.$noty.success("image  ajouter avec Succès ! ");
          this.isCreatingAnn = false;
          this.imageDataRio = "";
          // this.$router.push("/home/client/dashboard");

          this.messages.push(res.message);
          setTimeout(this.scrollToEnd, 100);
        })

        .catch((error) => {
          this.isCreatingAnn = false;
          //console.log(error.response.data);
          if (error.response && error.response.status == 422) {
            this.validationErrors = error.response.data.errors;
          }
        });
      /*  axios
        .get(
          `${apiDomain}/api/conversation/${contact.depanneur_id}` +
            "?token=" +
            this.$store.state.token
        )
        .then((response) => {
          this.messages = response.data;
        }); */
    },

    previewImageRio: function (event) {
      // Reference to the DOM input element
      var input = event.target;
      // Ensure that you have a file before attempting to read it
      if (input.files && input.files[0]) {
        // create a new FileReader to read this image and convert to base64 format
        var reader = new FileReader();
        // Define a callback function to run, when FileReader finishes its job
        reader.onload = (e) => {
          // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
          // Read image as base64 and set to imageData
          this.imageDataRio = e.target.result;
        };
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsDataURL(input.files[0]);
      }
    },
    sendMessage(text) {
      if (!this.contact) {
        return;
      }
      axios
        .post(
          `${apiDomain}/api/conversationDepanneur/send` +
            "?token=" +
            this.$store.state.token,
          {
            contact_id: this.contact.depanneur_id,
            text: text,
            image: this.$refs.image.files[0],

            nameContact: this.$store.state.user.nom,
          }
        )
        .then((response) => {
          this.$emit("new", response.data);
        });
    },
  },
  components: { MessagesFeed, MessageComposer },
};
</script>

<style lang="scss" scoped>
.file-upload-form,
.image-preview {
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  padding: -6px;
}
img.preview {
  // width: 81px;
  width: 17px;
  height: 133px;
  background-color: white;
  border: 1px solid #ddd;
  padding: 5px;
}
.styleSendImage {
  margin-top: -116px;
}
.image {
  display: none;
}
.hideWeb {
  margin-top: -95px;
  margin-left: 745px;
}
.custom-file-upload {
  // border: 1px solid #ccc;
  display: inline-block;
  //padding: 6px 12px;
  cursor: pointer;
}
.conversation {
  flex: 5;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  h1 {
    font-size: 20px;
    padding: 10px;
    margin: 0;
    border-bottom: 1px dashed lightgray;
  }
}
</style>
